import type { FetchResult } from '@apollo/client';

export function assertMutationSucceeded(result: FetchResult<unknown>, fallback: string): void {
  const message = result.errors?.[0]?.message;
  if (message) throw new Error(message);
  if (!result.data) throw new Error(fallback);
}

export function errorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return String(error);
}
